import React from 'react';
import AdminLayout from '../../components/templates/layout/AdminLayout';
import ProfileFollowersManagement from '../../components/templates/admin/ProfileFollowersManagement';

const ProfileFollowersManagementPage = () => {
  return (
    <AdminLayout>
      <ProfileFollowersManagement />
    </AdminLayout>
  );
};

export default ProfileFollowersManagementPage;
